// Import the edliy_utils
import {
    makeResponsive,
    placeTitle,
    placeImage,
    placeInput,
    placeSlider,
    hoverMe,
    placeRec,
    hiddenPt,
    fixedPt,
    clearInputFields,
    dragMe,
    placeArrow,
    placeGravity,
    placeText,
    placeLine,
    placePoint,
    placeGlider,
    placeRuler,
    placeLeftText,
    placeSliderSwitch,
    placeLogo,
    placeShuffle,
    placeTest
} from '../../../../common/edliy_utils-geometric';
const Boxes = {
box1: function () {
JXG.Options.point.showInfoBox=false;
JXG.Options.point.highlight=false;
JXG.Options.text.highlight=false;
JXG.Options.text.fixed=true;
JXG.Options.curve.highlight=false;
JXG.Options.text.cssDefaultStyle='fontFamily:Oswald;'
var brd1 = JXG.JSXGraph.initBoard('jxgbox1',{boundingbox: [-8, 12, 8, -4],
    keepaspectratio: true, axis:true, ticks:{visible:false},
    grid:true, showCopyright:false, showNavigation:false,
    pan:{enabled:false}, zoom:{enabled:false}});
brd1.options.layer['image']=14;
brd1.suspendUpdate();
//Title
makeResponsive(brd1);
placeTitle(brd1, 'Maxima & Minima of a Function: y=f(x)', 'Drag the Slider to Maxima or Minima of the Curve');
//brd1.create('text', [0, 9, '<b> Maxima and Minima </b>'], {anchorX:'middle', fixed:true, fontSize:function(){return 32*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});
placeLogo(brd1);
//Variables
var qa = [+4,0.5,-1,-2,4];
var qb = [+2,-1, 2,2,2];
var qc = [-3, 4, 2,4,3];
var n = 5;
var a1 = -2;
var b1 = 4;
var c1 = 6;
var o1 = 3;
var txta1 = '-2 x^3';
var txtb1 = ' + 4 x ';
var txtb11 = ' + 4';
var txtc1 = '+ 6';
var txto1= ' ';
var r1 = 0;
var r2 = 0;
var df2 = 2;
var delta = 0.25;

//Shuffle image
brd1.create('image', ['/assets/rectt.svg', [-7.5, 4], [4, 6]], {highlight:false, fixed: true});
brd1.create('image', ['/assets/rectt.svg', [-7.5, 1], [4, 6]], {highlight:false, fixed: true});
var shuffle1 = placeShuffle(brd1);
placeTest(brd1);
//brd1.create('image', ['/assets/shuffle.svg', [4.25, 4.25], [1.5, 1.5]], {visible: true, fixed: true});
shuffle1.setLabel('Shuffle')
shuffle1.label.setAttribute({visible:false, offset:[15, -15], CssStyle:'fontFamily:Oswald', fontSize:16});
shuffle1.on('over', function () {this.label.setAttribute({visible:true});});
shuffle1.on('out', function () {this.label.setAttribute({visible:false});});
//Shuffle function
shuffle1.on('down',function(){
    //pointOfInflection.setAttribute({visible: false});
    //localMaxima.setAttribute({visible: false});
    //localMinima.setAttribute({visible: false});
    //pt1X.setAttribute({visible: false});
    //pt1Y.setAttribute({visible: false});
    //pt2X.setAttribute({visible: false});
    //pt2Y.setAttribute({visible: false});
    //pt3X.setAttribute({visible: false});
    //pt3Y.setAttribute({visible: false});
    perpx1.setAttribute({visible: false});
    perpy1.setAttribute({visible: false});
    perpx2.setAttribute({visible: false});
    perpy2.setAttribute({visible: false});
    perpx3.setAttribute({visible: false});
    perpy3.setAttribute({visible: false});
    pt1.moveTo([0, 5], 10);
    o1=0;
    while(o1 < 2){
        o1 = Math.round(Math.random()*3);
    }

        n = Math.floor(Math.random()*qa.length);

        a1=0;

        while(a1 == 0){
            a1 = qa[n];
            txta1 = a1 + ' x^' + o1 + ' ';
        }

        b1=0;
        while(b1 == 0){
            b1 = qb[n];

            if(b1>= 0){
                txtb1 = '+ ' + b1 + ' x ';
                txtb11= '+ ' + b1;
            }
            else{
                txtb1 = ' ' + b1 + ' x ';
                txtb11 = ' ' + b1;
            }
        }

        c1=0;
        while(c1 == 0){
            c1 = qc[n];

            if(c1>= 0){
                txtc1 = '+ ' + c1;
            }
            else{
                txtc1 = c1;
            }

        }

        //console.log('a1 = ', a1);
        //console.log('b1 = ', b1);
        //console.log('c1 = ', c1);
        //console.log('o1 = ', o1);

        txto11();

});

function txto11(){

    if((o1-2)==0){
        //console.log('txto11 o1=', o1),
        txto1 = ' ';
    }

    else if((o1-2)==1){
        txto1 = 'x';
    }

    else {
        txto1 = 'x^' + (o1-2);
    }


 };



//Variables and graphs
var pos1 = 0;
var pos2 = 0;
var pos3 = 25;

var graph1 = brd1.create('functiongraph',
                                  [function(x){ return a1*Math.pow(x,o1)+b1*x + c1;},  -10,10], {strokeWidth:4, strokeColor: 'red'}
                                  );

var graph11 = brd1.create('curve',
                                    [function(x){ return x ;}, function(x){ return a1*Math.pow(x,o1)+b1*x + c1;},  -10,10], {visible: false}
                                    );

var graph111 = brd1.create('curve',
                                    [function(x){ return x + pos3 ;}, function(x){ return a1*Math.pow(x,o1)+b1*x + c1;},  -1,1], {visible: false}
                                    );


// f(x)
//var axisY1 = brd1.create('segment', [[pos1, 0], [pos1, 6]],  {fixed: true, firstArrow:false, lastArrow:true , strokeColor:'grey', strokeWidth: 1.5});
//var axisX1 = brd1.create('segment', [[pos1, 0], [pos1 + 2, 0]],  {fixed: true, firstArrow:false, lastArrow:true , strokeColor:'grey', strokeWidth: 1.5});

var y1txt = brd1.create('text', [ 0.25, 8.5, 'y'], {anchorX:'middle', fixed:true,  strokeColor:'black', anchorX:'left', anchorY:'bottom', fontSize:function(){return 22*brd1.canvasHeight/800}});
var x1txt = brd1.create('text', [ 7, 0.125, 'x'], {anchorX:'left', anchorY:'bottom', fixed:true, strokeColor:'black',  fontSize:function(){return 22*brd1.canvasHeight/800}});
// f'(x)
var firstDer = brd1.create('derivative', [graph11],  {strokeWidth:4, strokeColor: 'blue'});
////////////////////////////////////////////
var axisY2 = brd1.create('segment', [[pos2, 0], [pos2, 6]],  {visible: false, fixed: true, firstArrow:false, lastArrow:true , strokeColor:'grey', strokeWidth: 1.5});
var axisX2 = brd1.create('segment', [[pos2, 0], [pos2 + 2, 0]],  {visible: false, fixed: true, firstArrow:false, lastArrow:true , strokeColor:'grey', strokeWidth: 1.5});

//var y2txt = brd1.create('text', [ pos2-0.6, 6, "f'(x)"], {visible: false, anchorX:'middle', fixed:true,  strokeColor:'grey', fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});
//var x2txt = brd1.create('text', [ pos2 +2, -0.5, 'x'], {visible: false, anchorX:'middle', fixed:true, strokeColor:'grey', fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});

// f''(x)
var graph3 = brd1.create('derivative', [graph111], {visible: false});

var secondDer = brd1.create('derivative', [graph3], {strokeWidth: 2, strokeColor: 'green'});

var axisY3 = brd1.create('segment', [[pos3, 0], [pos3, 6]],  {fixed: true, firstArrow:false, lastArrow:true , strokeColor:'grey', strokeWidth: 1.5});
var axisX3 = brd1.create('segment', [[pos3, 0], [pos3 + 2, 0]],  {fixed: true, firstArrow:false, lastArrow:true , strokeColor:'grey', strokeWidth: 1.5});

//var y3txt = brd1.create('text', [ pos3-0.6, 6, "f''(x)"], {anchorX:'middle', fixed:true, strokeColor:'grey', fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});
//var x3txt = brd1.create('text', [ pos3 +2, -0.5, 'x'], {anchorX:'middle', fixed:true, strokeColor:'grey',  fontSize:function(){return 18*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});

//ROOTS
var axisX2line = brd1.create('line', [[pos2, 0], [pos2 + 2, 0]],  {visible: false, fixed: true, firstArrow:false, lastArrow:true , strokeColor:'grey', strokeWidth: 1.5});
var zero1 =brd1.create('intersection',[axisX2line, firstDer, 0],{visible: false, size:4, name:'Zero', withLabel:true, face:'square', fillColor:'yellow', txtokeColor:'black', shadow:true});
var root3Point =brd1.create('intersection',[axisX2line, secondDer, 0],{visible: false, size:4, name:'Zero', withLabel:true, face:'square', fillColor:'yellow', txtokeColor:'black', shadow:true});

var root1Point =brd1.create('point',[function(){

    if(isNaN(zero1.X())){

        r1 = 100;
        //console.log('DOES NOT INTERSECT r1' , r1);
    }

    else{
        if((o1 == 3 && a1 < 0 && b1 > 0) || (o1 == 3 && a1 > 0 && b1 < 0)){

            r1 = Math.sqrt(-b1/(a1*o1));
            //console.log('CUADRATIC r1' , r1);
            //console.log('a' , a1);
            //console.log('b' , b1);
            //console.log('c' , c1);
        }
        else{
            r1 = zero1.X();
            //console.log('LINEAL r1' , r1);
        }
    }

    return r1;

}, 0],{visible: false, size:4, name:'Root 1', withLabel:true, face:'square', fillColor:'yellow', strokeColor:'black', shadow:true, label: {fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});


var root2Point =brd1.create('point',[function(){

    if(isNaN(zero1.X())){

    r2 = 100;
    //console.log('DOES NOT INTERSECT r2' , r2);
}

else{
    if((o1 == 3 && a1 < 0 && b1 > 0) || (o1 == 3 && a1 > 0 && b1 < 0)){

        r2 = -Math.sqrt(-b1/(a1*o1));
        //console.log('CUADRATIC r2' , r2);
        //console.log('a' , a1);
        //console.log('b' , b1);
        //console.log('c' , c1);
    }
    else{
        r2 = 100;
        //console.log('LINEAL r2' , r2);
    }
}

return r2;

}, 0],{visible: false, size:4, name:'Root 2', withLabel:true, face:'square', fillColor:'yellow', strokeColor:'black', shadow:true, label: {fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
//MAX AND MIN
var ptCritical1 =brd1.create('point',[function(){ return root1Point.X() + pos1}, function(){return a1*Math.pow((root1Point.X()),o1)+b1*(root1Point.X()) + c1}],{size:0, name:' ', withLabel:true, face:'square', fillColor:'yellow', strokeColor:'black', shadow:true, label: {fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
var ptCritical2 =brd1.create('point',[function(){ return root2Point.X() + pos1}, function(){return a1*Math.pow((root2Point.X()),o1)+b1*(root2Point.X()) + c1}],{size:0, name:' ', withLabel:true, face:'square', fillColor:'yellow', strokeColor:'black', shadow:true, label: {fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'}});
var ptCritical3 =brd1.create('point',[function(){ return root3Point.X() + pos1 - pos3}, function(){return a1*Math.pow((root3Point.X() - pos3),o1)+b1*(root3Point.X() - pos3) + c1}],{visible: false, size:4, name:' ', withLabel:true, face:'square', fillColor:'yellow', strokeColor:'black', shadow:true, label: {fontSize:function(){return 14*brd1.canvasHeight/800}}});
//////////////////////////////////////////////
var pt1 = brd1.create('glider', [0, 5, graph1], {visible: true, name:'Drag me!' , attractors: [ptCritical1, ptCritical2], size:4, strokeColor:'black', fillColor:'red', attractorDistance: 0.5, label:{fontSize:function(){return 18*brd1.canvasHeight/800}}});
pt1.on('down', function () {this.setLabel('y = F(x)')});
pt1.on('up',function () {this.setLabel('Drag me!')});
//pt1.label.setAttribute({fontSize:function(){return 24*brd1.canvasHeight/800}})
//var tng = brd1.create('tangent', [pt1], {visible: true});
//var st = brd1.create('slopetriangle', [tng], {visible: true});

var polynomial1 = brd1.create('text', [-7, 7.5, function(){return  "F(x) = " + txta1 + txtb1 + txtc1 }],{color:'red', anchorX: 'left', anchorY: 'middle', fontSize:function(){return Math.round(22*brd1.canvasWidth/800.)}},);
var polynomial1_1 = brd1.create('text', [-7, 6.5, function(){return  "F(" + (pt1.X()-pos1).toFixed(2) +  ") = " +  (a1*Math.pow((pt1.X()-pos1), o1)+b1*(pt1.X()-pos1)+c1).toFixed(2) }],{color:'red', fixed: true, anchorX: 'left', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(22*brd1.canvasWidth/800.)}},);
//
//placeLine(brd1, [-12, 6], [-2, 6], 1, 'black');
//placeLine(brd1, [-12, 6.1], [-2, 6.1], 1, 'black');
var perpx1 = brd1.create('segment', [[()=>pt1.X(),0], pt1], {visible: false,fixed: true, strokeWidth: 1, strokeColor: 'grey', dash: 1});
var perpy1 = brd1.create('segment', [[0,()=>pt1.Y()], pt1], {visible: false,fixed: true, strokeWidth: 1, strokeColor: 'grey', dash: 1});
//
var pt1X = brd1.create('text', [ function(){return pt1.X()}, -0.5, function(){return (-pos1 + pt1.X()).toFixed(2)}], {visible: false,anchorX:'middle', fixed:true, fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});
var pt1Y = brd1.create('text', [ pos1 - 0.5,  function(){return pt1.Y()}, function(){return (pt1.Y()).toFixed(2)}], {visible: false,anchorX:'middle', fixed:true, fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});
////////////////////////////////////////////////////////////
var polynomial2 = brd1.create('text', [-7, 4.5, function(){return  "F '(x) = " + a1*o1 + 'x^' + (o1-1) + txtb11 }],{color:'blue', fixed: true, anchorX: 'left', anchorY: 'middle', fontSize:function(){return Math.round(22*brd1.canvasWidth/800.)}},);
var polynomial2_1 = brd1.create('text', [-7, 3.5, function(){return  "F '(" + (pt1.X()-pos1).toFixed(2) +  ") = " + (a1*o1*Math.pow((pt1.X()-pos1),(o1-1))+b1).toFixed(2) }],{
  color:'blue', fixed: true, anchorX: 'left', anchorY: 'middle',fontSize:function(){return Math.round(22*brd1.canvasWidth/800.)}},);
//placeLine(brd1, [-12, 4], [-2, 4], 1, 'black');
//placeLine(brd1, [-12, 4.1], [-2, 4.1], 1, 'black');
//////////////////////////////////////////////////////////////
var pt2 = brd1.create('point', [function(){return pt1.X() - pos1}, function(){return a1*o1*Math.pow((pt1.X()- pos1),(o1-1)) + b1}], {size:4, name:'y = F \'(x)',visible: true, strokeColor:'black', fillColor:'blue', label:{anchorY:'middle',fontSize:function(){return 18*brd1.canvasHeight/800}}  /*, attractors: [pintersection], attractorDistance: 1 */});
//
var perpx2 = brd1.create('perpendicularsegment', [axisX2, pt2], {visible: false,fixed: true, strokeWidth: 2, strokeColor: 'grey', dash: 1});
var perpy2 = brd1.create('perpendicularsegment', [axisY2, pt2], {visible: false,fixed: true, strokeWidth: 2, strokeColor: 'grey', dash: 1});

//var pt2X = brd1.create('text', [ function(){return pt2.X()}, -0.5, function(){return (-pos2 + pt2.X()).toFixed(2)}], {visible: false, anchorX:'middle', fixed:true, fontSize:function(){return 14*brd1.canvasHeight/800}});
//var pt2Y = brd1.create('text', [ pos2 - 0.5,  function(){return pt2.Y()}, function(){return (pt2.Y()).toFixed(2)}], {visible: false,anchorX:'middle', fixed:true, fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});

var polynomial3 = brd1.create('text', [7.5, -4, function(){return  "f''(x) = " + a1*o1*(o1-1) + txto1}],{visible:false, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);
var polynomial3_1 = brd1.create('text', [7.5, -5.5, function(){

    if((o1-2)==0){
        return  "f''(" + (pt1.X()-pos1).toFixed(2) +  ") = " + (a1*o1).toFixed(2)
    }

    else{
        return  "f''(" + (pt1.X()-pos1).toFixed(2) +  ") = " + (a1*o1*(o1-1)*Math.pow((pt1.X()-pos1),(o1-2))).toFixed(2)
    }
}],{visible: true, fixed: true, anchorX: 'middle', anchorY: 'middle', CssStyle:'fontFamily:Oswald', visible:false, fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}},);

var pt3 = brd1.create('point', [function(){return pt1.X()-pos1 + pos3}, function(){

    if((o1-2)<=0){
        //console.log('o1 first', o1)
        return a1*o1;
    }
    else{
        //console.log('valor', a1*o1*(o1-1)*Math.pow((pt1.X()-pos1),(o1-2)));
        //console.log('o1 second', o1)

        return a1*o1*(o1-1)*Math.pow((pt1.X()-pos1),(o1-2));

    } }], {visible: true, fixed: true});

var perpx3 = brd1.create('perpendicularsegment', [axisX3, pt3], {visible: false,fixed: true, strokeWidth: 2, strokeColor: 'grey', dash: 1});
var perpy3 = brd1.create('perpendicularsegment', [axisY3, pt3], {visible: false,fixed: true, strokeWidth: 2, strokeColor: 'grey', dash: 1});

//var pt3X = brd1.create('text', [ function(){return pt3.X()}, -0.5, function(){return (-pos3 + pt3.X()).toFixed(2)}], {visible: false,anchorX:'middle', fixed:true, fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});
//var pt3Y = brd1.create('text', [ pos3 - 0.5,  function(){return pt3.Y()}, function(){return (pt3.Y()).toFixed(2)}], {visible: false,anchorX:'middle', fixed:true, fontSize:function(){return 14*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});

//TEXTS
var localMaxima = brd1.create('text', [4, 7, 'You are at a Local Maxima'], {visible: ()=>pt1.X()==ptCritical1.X()&&pt1.Y()==ptCritical1.Y(), anchorX:'middle', fixed:true, fontSize:function(){return 22*brd1.canvasHeight/800},display:'internal'});
var localMinima = brd1.create('text', [4, 7,  'You are at a Local Minima'], {visible:()=>pt1.X()==ptCritical2.X()&&pt1.Y()==ptCritical2.Y(), anchorX:'middle', fixed:true, fontSize:function(){return 22*brd1.canvasHeight/800},display:'internal'});
//var pointOfInflection = brd1.create('text', [function(){return pt1.X() + 1}, function(){return pt1.Y() + 1}, 'Point of Inflection'], {visible: false, anchorX:'middle', fixed:true, fontSize:function(){return 22*brd1.canvasHeight/800}, cssStyle:'fontFamily:Oswald;'});

//CHECK MAXIMUM< MINIMUN AND POINT OF INFLECTION
function secondDerivate() {

    if((o1-2)==0){
        df2 = (a1*o1).toFixed(0);
    }

    else{
        df2 = (a1*o1*(o1-1)*Math.pow((pt1.X()-pos1),(o1-2))).toFixed(0);
    }
}

/*
(a1*o1*Math.pow((pt1.X()-pos1),(o1-1))+b1).toFixed(0)
(a1*o1*Math.pow((pt1.X()-pos1 - delta),(o1-1))+b1).toFixed(0)
(a1*o1*Math.pow((pt1.X()-pos1 + delta),(o1-1))+b1).toFixed(0)
*/

function checkMaxMin() {

    secondDerivate();

    //console.log('der primera = ', (a1*o1*Math.pow((pt1.X()-pos1),(o1-1))+b1).toFixed(0) );
    //console.log('df2 = ', df2);
    //console.log('Pd - 0.5 = ', (a1*o1*Math.pow((pt1.X()-pos1 - delta),(o1-1))+b1).toFixed(0) );
    //console.log('Pd + 0.5 = ', (a1*o1*Math.pow((pt1.X()-pos1 + delta),(o1-1))+b1).toFixed(0) );
    //console.log('Pd - delta = ', (pt1.X()-pos1 - delta).toFixed(0) );
    //console.log('Pd + delta = ', (pt1.X()-pos1 + delta).toFixed(0) );
if((a1*o1*Math.pow((pt1.X()-pos1),(o1-1))+b1).toFixed(0) == 0 && df2 < 0){

    console.log('local maxima');
    localMaxima.setAttribute({visible: true});
    localMinima.setAttribute({visible: false});
    //pointOfInflection.setAttribute({visible: false});

}

else if((a1*o1*Math.pow((pt1.X()-pos1),(o1-1))+b1).toFixed(0) == 0 && df2>0){

    console.log('local minima');
    localMinima.setAttribute({visible: true});
    localMaxima.setAttribute({visible: false});
    //pointOfInflection.setAttribute({visible: false});
}

else if( /*(a1*o1*Math.pow((pt1.X()-pos1),(o1-1))+b1).toFixed(0) == 0  && */ df2 == 0){

    if((a1*o1*Math.pow((pt1.X()-pos1 - delta),(o1-1))+b1).toFixed(0) > 0 && (a1*o1*Math.pow((pt1.X()-pos1 + delta),(o1-1))+b1).toFixed(0) < 0){

        console.log('local maxima inside third case');
        localMaxima.setAttribute({visible: true});
        localMinima.setAttribute({visible: false});
        //pointOfInflection.setAttribute({visible: false});
    }

    else if((a1*o1*Math.pow((pt1.X()-pos1 - delta),(o1-1))+b1).toFixed(0) < 0 && (a1*o1*Math.pow((pt1.X()-pos1 + delta),(o1-1))+b1).toFixed(0) > 0){

        console.log('local minima inside third case');
        localMinima.setAttribute({visible: true});
        localMaxima.setAttribute({visible: false});
        //pointOfInflection.setAttribute({visible: false});
    }

    else if( ( /*(pt1.X()-pos1)==0 &&*/ (a1*o1*Math.pow((pt1.X()-pos1 - delta),(o1-1))+b1).toFixed(0) > 0 && (a1*o1*Math.pow((pt1.X()-pos1 + delta),(o1-1))+b1).toFixed(0) > 0) ||
             ( /*(pt1.X()-pos1)==0 &&*/ (a1*o1*Math.pow((pt1.X()-pos1 - delta),(o1-1))+b1).toFixed(0) < 0 && (a1*o1*Math.pow((pt1.X()-pos1 + delta),(o1-1))+b1).toFixed(0) < 0)
    ){

        console.log('point of inflection inside third case');
        //pointOfInflection.setAttribute({visible: true});
        localMaxima.setAttribute({visible: false});
        localMinima.setAttribute({visible: false});
    }


    }

else{
    console.log('its nothing');
    //pointOfInflection.setAttribute({visible: false});
    localMaxima.setAttribute({visible: false});
    localMinima.setAttribute({visible: false});

}
};


function changeVisibilities() {
    perpx1.setAttribute({visible: false});
    perpy1.setAttribute({visible: false});

    perpx2.setAttribute({visible: false});
    perpy2.setAttribute({visible: false});

    perpx3.setAttribute({visible: false});
    perpy3.setAttribute({visible: false});

}

function changeVisibilities2() {

    perpx1.setAttribute({visible: true});
    perpy1.setAttribute({visible: true});

    perpx2.setAttribute({visible: true});
    perpy2.setAttribute({visible: true});

    perpx3.setAttribute({visible: true});
    perpy3.setAttribute({visible: true});

}
//ptCritical1.on('over', function(){localMaxima.setAttribute({visible:true})});
//ptCritical2.on('over', function(){localMinima.setAttribute({visible:true})});
//ptCritical1.on('out', function(){localMaxima.setAttribute({visible:false})});
//ptCritical2.on('out', function(){localMinima.setAttribute({visible:false})});
/////////////
pt1.on('drag', checkMaxMin);
pt1.on('up', changeVisibilities);
pt1.on('down', changeVisibilities2);
brd1.unsuspendUpdate();
}
}
export default Boxes;
